import { AutoLockFormsLevelType, FormNames } from '../autoLockForms.constants';

const formFields = [
  {
    name: 'borrowerType',
    label: 'Borrower Type',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'firstName',
    label: 'First Name',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'middleName',
    label: 'Middle Name',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'lastName',
    label: 'Last Name',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'suffix',
    label: 'Suffix',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'dateOfBirth',
    label: 'Date of Birth',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'ssn',
    label: 'Social Security Number',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'citizenshipStatus',
    label: 'Citizenship status',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'hasItin',
    label: 'Has ITIN',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'maritalStatus',
    label: 'Marital status',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'numberOfDependents',
    label: 'Dependents',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'ageOfDependents',
    label: 'Dependent Age',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'relation',
    label: 'Relationship',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'spouseFirstName',
    label: 'Spouse First Name',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'spouseLastName',
    label: 'Spouse Last Name',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'spouseEmail',
    label: 'Spouse Email',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'cellPhone',
    label: 'Cell',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'homePhone',
    label: 'Home',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'workPhone',
    label: 'Business',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'workPhoneNumberExtension',
    label: 'Business Number Extension',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'email',
    label: 'Email Address',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'isLiveTogetherForTwoYears',
    label: 'Copy borrower address history',
    levelType: AutoLockFormsLevelType.FIELD,
  },
];

export const borrowerInfoForm = {
  name: FormNames.BORROWER_INFO,
  label: 'Borrower',
  levelType: AutoLockFormsLevelType.FORM,
  children: formFields,
};
